var map = {
	"./Abkhazia.png": "kKUH",
	"./Afghanistan.png": "RD/O",
	"./Aland.png": "WQUe",
	"./Albania.png": "Pd7q",
	"./Algeria.png": "cxme",
	"./American-Samoa.png": "CI1o",
	"./Andorra.png": "3f0a",
	"./Angola.png": "+pyC",
	"./Anguilla.png": "ziSF",
	"./Antarctica.png": "/VGC",
	"./Antigua-and-Barbuda.png": "6/C7",
	"./Argentina.png": "Nikt",
	"./Armenia.png": "1ErE",
	"./Aruba.png": "35hK",
	"./Australia.png": "yDN8",
	"./Austria.png": "lHKN",
	"./Azerbaijan.png": "0oS5",
	"./Bahamas.png": "l0vA",
	"./Bahrain.png": "h67n",
	"./Bangladesh.png": "iZqo",
	"./Barbados.png": "1w6J",
	"./Basque-Country.png": "+B03",
	"./Belarus.png": "oLaq",
	"./Belgium.png": "G1/L",
	"./Belize.png": "YPjk",
	"./Benin.png": "9ZVx",
	"./Bermuda.png": "ZXKb",
	"./Bhutan.png": "pM17",
	"./Bolivia.png": "EYzR",
	"./Bosnia-and-Herzegovina.png": "F6HW",
	"./Botswana.png": "/sAW",
	"./Brazil.png": "FTHk",
	"./British-Antarctic-Territory.png": "fBFD",
	"./British-Virgin-Islands.png": "+Plt",
	"./Brunei.png": "S2nf",
	"./Bulgaria.png": "iAgY",
	"./Burkina-Faso.png": "w/HP",
	"./Burundi.png": "5+eM",
	"./Cambodia.png": "39sZ",
	"./Cameroon.png": "BZaC",
	"./Canada.png": "JCav",
	"./Canary-Islands.png": "3yn2",
	"./Cape-Verde.png": "RxKK",
	"./Cayman-Islands.png": "zhwm",
	"./Central-African-Republic.png": "hn9R",
	"./Chad.png": "v5EX",
	"./Chile.png": "WGg7",
	"./China.png": "DdT0",
	"./Christmas-Island.png": "1tBR",
	"./Cocos-Keeling-Islands.png": "dTRi",
	"./Colombia.png": "IbTm",
	"./Commonwealth.png": "9p0u",
	"./Comoros.png": "7Efo",
	"./Cook-Islands.png": "/zpW",
	"./Costa-Rica.png": "M7cX",
	"./Cote-dIvoire.png": "DBYu",
	"./Croatia.png": "XMnw",
	"./Cuba.png": "3JgT",
	"./Curacao.png": "UmQn",
	"./Cyprus.png": "28Nl",
	"./Czech-Republic.png": "P8Vc",
	"./Democratic-Republic-of-the-Congo.png": "eFWf",
	"./Denmark.png": "lGAZ",
	"./Djibouti.png": "TIGS",
	"./Dominica.png": "RzU3",
	"./Dominican-Republic.png": "RElN",
	"./East-Timor.png": "ZjgG",
	"./Ecuador.png": "ekXE",
	"./Egypt.png": "RLZj",
	"./El-Salvador.png": "Rosp",
	"./England.png": "FaXu",
	"./Equatorial-Guinea.png": "ZoY1",
	"./Eritrea.png": "KhI2",
	"./Estonia.png": "wzUM",
	"./Ethiopia.png": "xL+F",
	"./European-Union.png": "GUJi",
	"./Falkland-Islands.png": "pKkF",
	"./Faroes.png": "y6vj",
	"./Fiji.png": "kAQp",
	"./Finland.png": "w5Ij",
	"./France.png": "sADJ",
	"./French-Polynesia.png": "pBio",
	"./French-Southern-Territories.png": "SISM",
	"./Gabon.png": "cyJX",
	"./Gambia.png": "q6/r",
	"./Georgia.png": "lmpj",
	"./Germany.png": "mNd9",
	"./Ghana.png": "Wvpu",
	"./Gibraltar.png": "BDM2",
	"./GoSquared.png": "zuXM",
	"./Greece.png": "mNCz",
	"./Greenland.png": "EqGz",
	"./Grenada.png": "QLan",
	"./Guam.png": "suh5",
	"./Guatemala.png": "77vP",
	"./Guernsey.png": "lZJU",
	"./Guinea-Bissau.png": "eIad",
	"./Guinea.png": "5T+X",
	"./Guyana.png": "/R9c",
	"./Haiti.png": "+Cff",
	"./Honduras.png": "V4sH",
	"./Hong-Kong.png": "2lJm",
	"./Hungary.png": "DIRy",
	"./Iceland.png": "HS+z",
	"./India.png": "jVcK",
	"./Indonesia.png": "M+fJ",
	"./Iran.png": "2QOx",
	"./Iraq.png": "b+67",
	"./Ireland.png": "8s0l",
	"./Isle-of-Man.png": "5OU8",
	"./Israel.png": "Uk31",
	"./Italy.png": "zYN4",
	"./Jamaica.png": "lOeU",
	"./Japan.png": "bVS2",
	"./Jersey.png": "IGgi",
	"./Jordan.png": "/wRj",
	"./Kazakhstan.png": "S6ZC",
	"./Kenya.png": "dGR3",
	"./Kiribati.png": "LVQv",
	"./Kosovo.png": "0765",
	"./Kuwait.png": "tnmt",
	"./Kyrgyzstan.png": "DVKX",
	"./Laos.png": "yQdh",
	"./Latvia.png": "Lp5r",
	"./Lebanon.png": "zq4E",
	"./Lesotho.png": "eil4",
	"./Liberia.png": "epK6",
	"./Libya.png": "w5Yi",
	"./Liechtenstein.png": "Mr53",
	"./Lithuania.png": "SWeA",
	"./Luxembourg.png": "jsR/",
	"./Macau.png": "AAtC",
	"./Macedonia.png": "NJGn",
	"./Madagascar.png": "e7Kf",
	"./Malawi.png": "2Tu5",
	"./Malaysia.png": "ko6Q",
	"./Maldives.png": "PT6a",
	"./Mali.png": "i1Z1",
	"./Malta.png": "xWN6",
	"./Mars.png": "R020",
	"./Marshall-Islands.png": "8bNB",
	"./Martinique.png": "iDF6",
	"./Mauritania.png": "+xvK",
	"./Mauritius.png": "gR7+",
	"./Mayotte.png": "5pNP",
	"./Mexico.png": "s6IB",
	"./Micronesia.png": "L2Iz",
	"./Moldova.png": "Tccf",
	"./Monaco.png": "3ciO",
	"./Mongolia.png": "CSGM",
	"./Montenegro.png": "ZGaf",
	"./Montserrat.png": "M/Le",
	"./Morocco.png": "oKZl",
	"./Mozambique.png": "mklt",
	"./Myanmar.png": "sdNW",
	"./NATO.png": "XXBf",
	"./Nagorno-Karabakh.png": "Oc6q",
	"./Namibia.png": "D8+n",
	"./Nauru.png": "BSMu",
	"./Nepal.png": "vB2M",
	"./Netherlands-Antilles.png": "p5HI",
	"./Netherlands.png": "E+CU",
	"./New-Caledonia.png": "xoZq",
	"./New-Zealand.png": "xgIA",
	"./Nicaragua.png": "uM74",
	"./Niger.png": "vqnU",
	"./Nigeria.png": "trAH",
	"./Niue.png": "2HIX",
	"./Norfolk-Island.png": "Jr/A",
	"./North-Korea.png": "NvYk",
	"./Northern-Cyprus.png": "LFvs",
	"./Northern-Mariana-Islands.png": "A+oh",
	"./Norway.png": "i9Ik",
	"./Olympics.png": "qqAj",
	"./Oman.png": "V4X5",
	"./Pakistan.png": "3iZJ",
	"./Palau.png": "KDtp",
	"./Palestine.png": "ScAL",
	"./Panama.png": "QZHf",
	"./Papua-New-Guinea.png": "UsYd",
	"./Paraguay.png": "8MbD",
	"./Peru.png": "ILyU",
	"./Philippines.png": "ZTKp",
	"./Pitcairn-Islands.png": "I2hW",
	"./Poland.png": "+Rzk",
	"./Portugal.png": "Yfyr",
	"./Puerto-Rico.png": "HVo5",
	"./Qatar.png": "0o9a",
	"./Red-Cross.png": "rx7G",
	"./Republic-of-the-Congo.png": "dmHV",
	"./Romania.png": "6lWR",
	"./Russia.png": "qXau",
	"./Rwanda.png": "cqyz",
	"./Saint-Barthelemy.png": "SslU",
	"./Saint-Helena.png": "oQ6n",
	"./Saint-Kitts-and-Nevis.png": "96a/",
	"./Saint-Lucia.png": "MpZN",
	"./Saint-Martin.png": "Rx//",
	"./Saint-Vincent-and-the-Grenadines.png": "qdeo",
	"./Samoa.png": "778Y",
	"./San-Marino.png": "Uc7U",
	"./Sao-Tome-and-Principe.png": "xes2",
	"./Saudi-Arabia.png": "8J7d",
	"./Scotland.png": "1W8X",
	"./Senegal.png": "v/nh",
	"./Serbia.png": "pCvi",
	"./Seychelles.png": "vKWb",
	"./Sierra-Leone.png": "EeIk",
	"./Singapore.png": "V2ld",
	"./Slovakia.png": "uSmG",
	"./Slovenia.png": "m/1c",
	"./Solomon-Islands.png": "qhOR",
	"./Somalia.png": "txTS",
	"./Somaliland.png": "uBm9",
	"./South-Africa.png": "lc2g",
	"./South-Georgia-and-the-South-Sandwich-Islands.png": "1xYr",
	"./South-Korea.png": "pkob",
	"./South-Ossetia.png": "bV8b",
	"./South-Sudan.png": "DY6e",
	"./Spain.png": "LBGR",
	"./Sri-Lanka.png": "RV82",
	"./Sudan.png": "Oqtn",
	"./Suriname.png": "ONJU",
	"./Swaziland.png": "7KYi",
	"./Sweden.png": "I9mj",
	"./Switzerland.png": "1Dm2",
	"./Syria.png": "y+Dg",
	"./Taiwan.png": "1//f",
	"./Tajikistan.png": "mNk3",
	"./Tanzania.png": "csX+",
	"./Thailand.png": "tJIu",
	"./Togo.png": "9L7t",
	"./Tokelau.png": "shM/",
	"./Tonga.png": "1gmT",
	"./Trinidad-and-Tobago.png": "NpZI",
	"./Tunisia.png": "33AM",
	"./Turkey.png": "jTi0",
	"./Turkmenistan.png": "72PN",
	"./Turks-and-Caicos-Islands.png": "yisL",
	"./Tuvalu.png": "kjzV",
	"./US-Virgin-Islands.png": "hIdP",
	"./Uganda.png": "CDmj",
	"./Ukraine.png": "TEOy",
	"./United-Arab-Emirates.png": "aK3T",
	"./United-Kingdom.png": "gkSi",
	"./United-Nations.png": "MK44",
	"./United-States.png": "f2mT",
	"./Unknown.png": "BkQx",
	"./Uruguay.png": "DJ1F",
	"./Uzbekistan.png": "AK1Q",
	"./Vanuatu.png": "NKat",
	"./Vatican.png": "MGc2",
	"./Venezuela.png": "QeI0",
	"./Vietnam.png": "FClX",
	"./Wales.png": "ydJz",
	"./Wallis-And-Futuna.png": "dyol",
	"./Western-Sahara.png": "jXxz",
	"./Yemen.png": "Wm0P",
	"./Zambia.png": "pA+H",
	"./Zimbabwe.png": "opzd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f1Y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags ^\.\/.*\.png$
// module id = 7f1Y
// module chunks = 0 62 63